import React, { useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useOrderSaleOrderSaleReceiptTypeInputQuery } from '../../../../../../../../services';
import { RhCheckbox } from '../../../../../../../dum';
import {
    IOrderSale,
    REQUIRE_INVOICE_CODE,
} from '../../order-sale-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function OrderSaleRequireInvoiceCodeInput() {
    const { data } = useOrderSaleOrderSaleReceiptTypeInputQuery();
    const { setValue } = useFormContext<IOrderSale>();
    const receiptTypeId = useWatch({
        name: 'receipt_type_id',
    }) as IOrderSale['receipt_type_id'];
    const invoiceCode = useWatch({
        name: 'invoice_code',
    }) as IOrderSale['invoice_code'];
    const previousInvoiceCodeRef = useRef(invoiceCode);
    const receiptType = (data?.getReceiptTypes ?? []).find(
        (type) => type.id === receiptTypeId,
    );

    return (
        <RhCheckbox
            name={REQUIRE_INVOICE_CODE}
            label={shortLabel(FIELD_LABELS.require_invoice_code)}
            disabled={!!receiptType && !receiptType.applies_tax}
            onChange={(checked) => {
                if (checked) {
                    setValue('invoice_code', previousInvoiceCodeRef.current ?? 0, {
                        shouldDirty: true,
                        shouldValidate: true,
                    });
                } else {
                    previousInvoiceCodeRef.current = invoiceCode;
                }
            }}
        />
    );
}
